export const logToDataLayer = (eventObject) => {
  if (window.dataLayer) {
    window.dataLayer.push(eventObject);
  }
};
